<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>

        <el-breadcrumb-item> 考级测试</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="1"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <div class="container_left_content_name">
              <span>会员号：</span>{{ row.kaoji.name }}
            </div>
            <div class="container_left_content_name">
              <span>题数：</span>{{ row.question_list.length }}道
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center">
          <div class="container_center_grade">得分：98分</div>
          <div class="container_center_content">
            恭喜您通过理论测试，请从下面的N道实践题中，任选一题，点击进入（也可以分别点击查看），内有相关教材或示范视频或示范文档的链接，请在15个工作日内，通过您的刻苦学习，按照实践题目的要求，上传由您亲自表演或创作的作品，上传成功后，等候评委在7个工作日内的审核，最终考试结果，将在您的考级申报窗口显示并同时用站内信箱显示，祝您成功！
          </div>
          <div class="container_center_btns">
            <el-button type="primary" plain="">返回首页</el-button>
            <el-button type="primary">实践考试</el-button>
          </div>
        </div>
        <div class="container_right">
          <div class="container_right_title">答题结果</div>
          <div class="container_right_content">
            <div v-for="(item, index) in row.question_list">
              <span :class="'status-' + item.is_right">
                <!--            答题状态 is_right  1是正确  2是错误  3未答题-->
                {{ index + 1 }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      last_time: 300 * 1000,
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
    };
  },
  components: {
    NewsListItem,
  },
  computed: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id || 0;
    if (that.row.id) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/examedoingdetail",
        {
          id: that.row.id,
        },
        (res) => {
          that.row = res.data;
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    searchFun() {
      this.$message({ type: "success", message: "search" });
    },
  },
};
</script>
<style scoped lang="scss">
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 699px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 56px 32px 20px 32px;
    .container_center_grade {
      height: 40px;
      font-size: 28px;
      font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
      font-weight: 500;
      color: #e02020;
      line-height: 40px;
      margin-bottom: 32px;
    }
    .container_center_content {
      width: 635px;
      height: 231px;
      font-size: 24px;

      font-weight: 400;
      color: #333333;
      line-height: 33px;
      margin-bottom: 40px;
    }
    .container_center_btns {
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
        &:nth-child(2) {
          margin-left: 24px;
        }
      }
    }
  }

  .container_right {
    width: 312px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 24px 32px 0 32px;
    .container_right_title {
      width: 122px;
      height: 33px;
      font-size: 24px;

      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
    .container_right_content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        display: inline-block;
        flex: 20%;
        span {
          display: inline-block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 20px;
          margin: 16px 0 0 0;
          flex: 20px;
          &:hover {
            cursor: default;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ExameResult.vue?58868452